import { createStore, createHook, type Action } from 'react-sweet-state';

interface State {
	shouldShow: boolean; // this is toggled to true when crossflowing
	isShown: boolean; // this is true when spotlight is actually shown
}

type Actions = {
	setIsShown: (isShown: boolean) => Action<State, void, void>;
	setShouldShow: (shouldShow: boolean) => Action<State, void, void>;
};

const store = createStore<State, Actions>({
	initialState: {
		shouldShow: false,
		isShown: false,
	},
	actions: {
		setShouldShow:
			(shouldShow: boolean) =>
			({ setState }) => {
				setState({ shouldShow });
			},
		setIsShown:
			(isShown: boolean) =>
			({ setState }) => {
				// once we've shown the spotlight, don't show it again
				setState({ isShown, shouldShow: false });
			},
	},
});

export const useLoomScriptRovoSpotlight = createHook(store);
